export enum RelationMutate {
    Cascade = 'cascade',
    Restrict = 'restrict',
    SetNull = 'setNull',
}
